// extracted by mini-css-extract-plugin
module.exports = {"content":"CallEvent_content__gknXk","fullWidth":"CallEvent_fullWidth__GiIN5","compact":"CallEvent_compact__25BuB","alert":"CallEvent_alert__3Mg7k"};